import { defineChannelContract } from 'shared/channels';
import { DomainMessagesTypes } from 'shared/domain/messages/message';

/** Contract of the worker's notices that it dropped stored data. */
export const dataFlushContract = defineChannelContract<{
  requests: Record<never, never>;
  events: {
    /** All user data was dropped (sign out, permissions changed). */
    [DomainMessagesTypes.dataFlushed]: undefined;
    /** The selected project's data was dropped (project switch, language change). */
    [DomainMessagesTypes.projectDataFlushed]: undefined;
  };
}>('dataFlushChannel');
